import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'
import {useRefetchOnAliveUpdate} from '../../../hooks/use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '../../../hooks/use-invalidate-on-alive-update'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export const useAssigneesQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'assignees')

export const useReviewRequestsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'review_requests')

/** Reads the review requests query key without subscribing to the query itself. */
export const useReviewRequestsQueryKey = () => useRouteQueryKey(pullRequestsOverviewRoute, 'review_requests')

export const useDevelopmentQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'development')

export const useLabelsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'labels')

export const useParticipantsQuery = () => useSuspenseRouteQuery(pullRequestsOverviewRoute, 'participants')

/** Automatically observes for live updates. */
export const useDeploymentsQuery = () => {
  const query = useSuspenseRouteQuery(pullRequestsOverviewRoute, 'deployments')

  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : query.data.aliveChannel, query.refetch)
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? query.data.aliveChannel : '', query.queryKey)

  return query
}
